import { render, staticRenderFns } from "./UDialog.vue?vue&type=template&id=674dbca8"
import script from "./UDialog.vue?vue&type=script&lang=js"
export * from "./UDialog.vue?vue&type=script&lang=js"
import style0 from "./UDialog.vue?vue&type=style&index=0&id=674dbca8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports